import type { Config } from '@ms/yammer-data/dist/state/types';

export default window.__yammerconfig__ as Config;
